import { defineAction, object } from '~/prix'
import sendTimeSeriesAlertEmail from './sendTimeSeriesAlertEmail.action.json'

const sendTimeSeriesAlertEmailDefinition = defineAction({
  ...sendTimeSeriesAlertEmail,
  input: object({}),
  output: object({}),
})

export default sendTimeSeriesAlertEmailDefinition
